import { cx } from 'class-variance-authority';
import React from 'react';

import './paginator.scss';

type RangeProps = {
   firstIndex: number;
   lastIndex: number;
};

type PaginationProps = {
   totalPages: number;
   currentPage: number;
   onPageClick?: (pageNumber: number) => void;
   setRange: (state: any) => void;
   range: RangeProps;
};

const activePage =
   'bg-slate-300 text-black shadow-lg transform transition duration-500 ease-in-out scale-110';

const PAG_PAGES = 5;

export const Paginator = ({
   totalPages,
   currentPage,
   onPageClick,
   setRange,
   range,
}: PaginationProps) => {
   const onNextClick = () => {
      let lastIndex = range.lastIndex + PAG_PAGES;
      if (lastIndex > totalPages) {
         lastIndex = totalPages;
      }
      onPageClick?.(range.lastIndex);
      setRange({
         firstIndex: range.firstIndex + PAG_PAGES,
         lastIndex: lastIndex,
      });
   };

   const onPrevClick = () => {
      if (range.firstIndex === 1) return;

      const newFirst = range.firstIndex - PAG_PAGES;
      const newLast = newFirst + PAG_PAGES;
      onPageClick?.(newLast - 1);

      setRange({
         firstIndex: newFirst,
         lastIndex: newLast,
      });
   };

   return (
      <div className="paginator">
         <ul className="paginator__list">
            <li>
               <button
                  className={cx('pag-trigger-btn', 'pag-trigger-btn--prev')}
                  onClick={onPrevClick}
                  disabled={range.firstIndex + PAG_PAGES === PAG_PAGES}
               >
                  {`<`}
               </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => i + 1)
               ?.slice(range.firstIndex, range.lastIndex)
               .map((pageNumber: number, idx: number) => (
                  <li key={`${idx}-${pageNumber}`}>
                     <button
                        onClick={() => onPageClick?.(pageNumber - 1)}
                        className={cx(
                           'pag-item',
                           currentPage === pageNumber - 1 && 'pag-item--active'
                        )}
                     >
                        {pageNumber}
                     </button>
                  </li>
               ))}

            <li>
               <button
                  className={cx('pag-trigger-btn', 'pag-trigger-btn--next')}
                  onClick={onNextClick}
                  disabled={range.firstIndex + PAG_PAGES >= totalPages}
               >
                  {`>`}
               </button>
            </li>
         </ul>
      </div>
   );
};
